module.exports = __webpack_public_path__ + "static/media/NextStepEmail.8d395073.svg";